import { EMAIL_ADDRESS_REGEX } from '@arnold/core';
import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const REGEXP_PHONE_NUMBER =
  /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/;

export const createPhoneNumberWithCallingCode = (phoneNumber: string, callindCode?: string) =>
  `${callindCode ? '+' + callindCode : ''}${phoneNumber}`;

export enum ContactType {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export const preparedValidationSchemaForContacts = (t: TFunction) => {
  return {
    primaryEmail: Yup.string()
      .test('check-email-format', t('enterValidWorkEmail'), function (value) {
        if (!value) return true;
        return EMAIL_ADDRESS_REGEX.test(String(value).toLowerCase());
      })
      .test('required-if-others-empty', t('enterContact'), function (value) {
        const { secondaryEmail, phone } = this.parent;
        if (!secondaryEmail && !phone) {
          return !!value;
        }
        return true;
      })
      .test('work-personal-differ', t('workAndPersonalEmailMustDiffer'), function (value) {
        const { secondaryEmail } = this.parent;
        if (!value?.trim() || !secondaryEmail?.trim()) return true;
        return value.trim().toLowerCase() !== secondaryEmail.trim().toLowerCase();
      }),

    secondaryEmail: Yup.string()
      .test('check-email-format', t('enterValidEmail'), function (value) {
        if (!value) return true;
        return EMAIL_ADDRESS_REGEX.test(String(value).toLowerCase());
      })
      .test('required-if-others-empty', t('enterContact'), function (value) {
        const { primaryEmail, phone } = this.parent;
        if (!primaryEmail && !phone) {
          return !!value;
        }
        return true;
      })
      .test('work-personal-differ', t('workAndPersonalEmailMustDiffer'), function (value) {
        const { primaryEmail } = this.parent;
        if (!value?.trim() || !primaryEmail?.trim()) return true;
        return value.trim().toLowerCase() !== primaryEmail.trim().toLowerCase();
      }),

    phone: Yup.string()
      .test('check-phone-format', t('enterValidPhone'), function (value) {
        if (!value) return true;
        return REGEXP_PHONE_NUMBER.test(value);
      })
      .test('required-if-others-empty', t('enterContact'), function (value) {
        const { primaryEmail, secondaryEmail } = this.parent;
        if (!primaryEmail && !secondaryEmail) {
          return !!value;
        }
        return true;
      }),

    callingCode: Yup.string()
      .matches(/^(\+?\d{1,3})$/, t('enterValidCallingCode'))
      .test('required-if-phone', t('enterCallingCode'), function (value) {
        const { phone } = this.parent;
        if (phone) {
          return !!value;
        }
        return true;
      }),

    preferredContactType: Yup.string().test('valid-contact-type', t('notValidPrefferedContact'), function (value) {
      const { primaryEmail, secondaryEmail, phone } = this.parent;

      // If only phone is provided, preferred contact must be SMS
      if (!primaryEmail && !secondaryEmail && phone) {
        return value === ContactType.Sms;
      }

      // If only email is provided, preferred contact must be Email
      if ((primaryEmail || secondaryEmail) && !phone) {
        return value === ContactType.Email;
      }

      return true;
    }),
  };
};
